export default __webpack_public_path__ + "static/media/Markers_Grey Marker - Offline.82f22c7b.svg";